import moment from "moment-timezone";
import userTypeConsts from "../../../../../constants/userTypeConsts.js";

/**
 * UI Helpers for CardBody Component
 * Contains UI-related utility functions
 */

/**
 * Calculate current text count for display
 * @param {string} text1 - First text
 * @param {string} text2 - Second text (optional)
 * @param {string} text3 - Third text (optional)
 * @returns {number} Total text length
 */
export const currentTextCount = (text1, text2, text3) => {
  const text = `${text1} ${text2 ? "-" + text2 : ""} ${text3 ? text3 : ""}`;
  return text.length;
};

/**
 * Get time components from time string
 * @param {string} timeString - Time string in HH:mm:ss format
 * @returns {Object} Object with hours, minutes, seconds
 */
export function getTimeComponents(timeString) {
  const [hours, minutes, seconds] = timeString.split(":").map(Number);
  return { hours, minutes, seconds };
}

/**
 * Check if timer entry is locked based on lock hours configuration
 * @param {string} date - Date string
 * @param {string} timeZone - Time zone string
 * @param {string} format - Date format string
 * @param {Object} user - User object
 * @returns {boolean} True if unlocked, false if locked
 */
export const getLockHours = (date, timeZone, format, user) => {
  if (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) {
    return true;
  }
  
  try {
    const lockData = global.config.timerLock();
    
    if (!lockData) {
      return true; // Default to unlocked if no lock data
    }
    
    const tz = global.config.getTimeZone();
    const currentDate = moment().tz(tz);
    const days = lockData.timerLock;
    const time = lockData.timerLockTime;
    
    if (!days || !time) {
      return true; // Default to unlocked if missing data
    }
    
    const time24Hour = moment(time, "h:mm A").format("HH:mm:ss");
    const timeComponents = getTimeComponents(time24Hour);
    // Calculate lock date: current date minus days, at specific time (fix mutation issue)
    const lockDate = moment(currentDate).subtract(days, "days").set({
      hour: timeComponents.hours,
      minute: timeComponents.minutes,
      second: timeComponents.seconds,
    });
    const inputDate = moment(date).tz(tz);
    
    // Return true if input date is >= lock date (unlocked), false if before lock date (locked)
    return inputDate.isSameOrAfter(lockDate);
  } catch (error) {
    return true; // Default to unlocked on error
  }
};

/**
 * Validate time format (HH:mm:ss)
 * @param {string} timeString - Time string to validate
 * @returns {boolean} True if valid
 */
export function validateTimeFormat(timeString) {
  const timeRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
  return timeRegex.test(timeString);
}
